import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { localStorageManager } from "@/services/localStorage";
import { LOCAL_STORAGE_BASE_KEYS } from "@/types/v2";

export interface ContainerMetricsBoard {
  selectedBoard: string | undefined;
  selectBoard: (board: string) => void;
}

export const useContainerMetricsBoard = (
  shopId: string | undefined,
  layoutNames: string[]
): ContainerMetricsBoard => {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlBoard = searchParams.get("board");
  const storedBoard = localStorageManager.getItem(
    LOCAL_STORAGE_BASE_KEYS.CONTAINER_METRICS_LAYOUT_ID,
    shopId
  );

  const selectedBoard = [urlBoard, storedBoard, layoutNames[0]].find(
    (candidate): candidate is string =>
      !!candidate && layoutNames.includes(candidate)
  );

  const selectBoard = useCallback(
    (board: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set("board", board);
          return next;
        },
        { replace: true }
      );
      localStorageManager.setItem(
        LOCAL_STORAGE_BASE_KEYS.CONTAINER_METRICS_LAYOUT_ID,
        board,
        shopId
      );
    },
    [setSearchParams, shopId]
  );

  return { selectedBoard, selectBoard };
};
